import { message, Spin } from "antd";
import { updateCounsilorImage } from "api/counsilors";
import { uploadImageToS3 } from "api/news";
import { base64ToBlob } from "components/CreateNews/components/helper";
import ModalFooter from "components/Modal/modalFooter";
import { useEffect, useRef, useState } from "react";
import { CameraIcon } from "themes/Icon";
import { isPermit } from "utils/permissionCheck";
import ModalComp from "../Modal";
import style from "./profile_upload.module.scss";
import "./profile_upload.scss";

function CounsilorProfileUpload({
  picture,
  data = [],
  fileList,
  fetchUsers,
  setFileList = () => {},
  previewImage,
  setPreviewImage = () => {},
}) {
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const defaultImageUrl = "/svg/upload-default.svg";
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    setPreviewImage(picture);
  }, [picture]);

  const callUpdateImageAPI = async (fileObj, actionType, filepath) => {
    let imageDetails = {
      councilor_image_name: fileObj.name,
      councilor_image_size: fileObj.size,
      councilor_image_mimetype: fileObj.type,
      councilor_image_filepath: filepath,
    };

    // Add 'councilor_image_id' if actionType is 'update'.
    if (actionType === "update") {
      imageDetails.councilor_image_id = data.councilor_image_id;
    }

    // Initialize payload with dynamic properties based on actionType
    let payload = {
      councilor_id: data?.councilor_id,
      action: actionType,
      images: actionType !== "delete" ? [imageDetails] : [],
    };

    // Add 'type' only if actionType is 'insert'
    if (actionType === "insert") {
      payload.type = 1;
    }

    try {
      const response = await updateCounsilorImage(payload);
      message.success(response?.message);
      // fetchUsers();
      // return response;
    } catch (error) {
      message.error("Failed to update user image");
      throw error; // To handle in calling function
    }
  };

  const handleFileInputChange = async (e) => {
    const newFileObject = e.target.files[0];
    if (newFileObject) {
      setLoading(true);
      try {
        const previewImageUrl = await getBase64(newFileObject);
        setPreviewImage(previewImageUrl);
        setPreviewTitle(newFileObject.name);
        setFileList([{ uid: Date.now(), originFileObj: newFileObject }]);

        // First upload to S3
        const userImageBlob = base64ToBlob(previewImageUrl);
        await uploadImageToS3(
          userImageBlob,
          data?.councilor_image_upload_s3_path
        );
        // Call the API for update action with the path returned from S3 upload
        await callUpdateImageAPI(
          newFileObject,
          data?.councilor_image_id !== null ? "update" : "insert",
          data?.councilor_image_upload_filepath
        );
        setLoading(false);
      } catch (error) {
        message.error("Failed to process file: " + error.message);
        setLoading(false);
      }
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await callUpdateImageAPI(null, "delete");
      setPreviewImage(null);
      setPreviewTitle("");
      setFileList([]);
      setPreviewOpen(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={style["avatar-upload-container"]}>
        <div
          onClick={() => {
            if (fileList.length || previewImage) {
              setPreviewOpen(true);
            }
          }}
        >
          <div
            className={style["avatar-uploader"]}
            style={{ position: "relative" }}
          >
            <img
              src={previewImage ? previewImage : defaultImageUrl}
              alt="preview"
              className={style["avatar-image"]}
            />
            {loading && (
              <div className={style["spinner-overlay"]}>
                <Spin size="large" />
              </div>
            )}
          </div>
        </div>
        {isPermit(7, "edit") && (
          <button
            className={`${style["upload-btn"]} ${
              fileList?.length ? style["upload-btn-hidden"] : ""
            }`}
            onClick={() => fileInputRef.current?.click()}
          >
            <CameraIcon />
          </button>
        )}
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          onChange={handleFileInputChange}
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
      <ModalComp
        setOpen={setPreviewOpen}
        footer={
          <ModalFooter
            handlePrimaryBtn={handleDelete}
            primaryBtnVariant="secondary"
            // primaryBtnText="Delete"
            hidePrimaryBtn
            hide
            primaryBtnloading={loading}
            hideSecondaryBtn={true}
          />
        }
        open={previewOpen}
        title="Profile photo"
      >
        <img
          className={style["preview-image"]}
          alt={previewTitle}
          src={previewImage != null ? previewImage : defaultImageUrl}
        />
      </ModalComp>
    </>
  );
}

export default CounsilorProfileUpload;
